import UpdateCueComponent from './updateCue.component';

export const updateCueModule = {
	name: 'updateCueComponent',
};

export default angular
	.module(updateCueModule.name, [])
	.component('updateCue', new UpdateCueComponent()).name;
